/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "bbwvideoauthapi",
            "endpoint": "https://agwtqgwfk1.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xziziv7j6reylgqsdphpnzghuy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-mns7y6esjvferhhr5cjhriwe3y",
    "aws_cognito_identity_pool_id": "us-east-1:154536a8-7430-489f-a2d2-25f3e91a92cd",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_OgD6sawWu",
    "aws_user_pools_web_client_id": "4drulf480ujo2pr9juc04tcuue",
    "oauth": {
        "domain": "webapp1-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://library.brainbased-wellness.com/,http://localhost:3000/",
        "redirectSignOut": "https://library.brainbased-wellness.com/",
        "responseType": "token"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "webappstoragea1d12-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
